var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("aside", { staticClass: "menu my-5" }, [
        _c("p", { staticClass: "menu-label" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("offices_title")) + "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "menu-list" },
          _vm._l(_vm.offices, function(office) {
            return _c("li", [
              _c(
                "a",
                {
                  class: {
                    "is-active": _vm.$store.state.currentOffice == office.id
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.switchOffice(office.id)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(office.name) +
                      "\n                "
                  )
                ]
              )
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("advertisements")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99e870ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-99e870ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/AppSidebar.vue
// module id = 623
// module chunks = 1